/**
 * A dónde lleva un botón de «Nueva cotización», según los módulos de la persona.
 *
 * Prixia tiene dos cotizadores y cada empresa tiene el suyo:
 * - DATEC trabaja con el Pricer Datec (`menu:pricer-datec`). Sus funcionarios
 *   NO deben entrar al cotizador general aunque lo tengan habilitado.
 * - Un cliente al que se le vende Prixia no tiene el Pricer Datec: sólo tiene el
 *   cotizador general (`menu:nueva-cotizacion`).
 *
 * Por eso se pregunta por el módulo y no por el nombre de la empresa ni por el
 * rol: lo decide la configuración de cada empresa, igual que el menú lateral.
 * Son las mismas llaves que mira `ProtectedRoute` para esas rutas (ver
 * `router/route-modules.ts`), así que el botón y la puerta no pueden discrepar.
 *
 * Devuelve `null` si la persona no tiene ninguno de los dos: el botón no se
 * muestra, en vez de llevar a «Módulo no disponible».
 */
export interface DestinoNuevaCotizacion {
  href: string;
  label: string;
}

export function destinoNuevaCotizacion(
  canSeeMenu: (menuKey: string) => boolean
): DestinoNuevaCotizacion | null {
  if (canSeeMenu('pricer-datec')) {
    return { href: '/pricer-datec/new', label: 'Nueva Cotización Datec' };
  }
  if (canSeeMenu('nueva-cotizacion')) {
    return { href: '/quotes/new', label: 'Nueva Cotización' };
  }
  return null;
}
